import { ComponentPropsWithoutRef } from 'react';
import { Box } from '@givebutter/primitives/box';
import { faSend } from '@fortawesome/pro-regular-svg-icons';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CreatedByLabel } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/components/CreatedByLabel';
import { getBadge } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/helpers';
import { Contact, EngageDeliveryActivity } from 'types/domain';

interface EngageLetterProps extends ComponentPropsWithoutRef<'div'> {
    contact: Contact;
    item: EngageDeliveryActivity;
}

const EngageLetter = ({ item, contact, ...divProps }: EngageLetterProps) => {
    const { name_display = '' } = contact;
    const { resource } = item;

    return (
        <Box className={'flex-row items-center justify-between'} {...divProps}>
            <div className={`flex flex-grow flex-col items-center justify-center p-2`}>
                <div
                    className={`flex w-full !cursor-default items-center justify-between gap-x-4 p-2`}
                >
                    <div className={'flex items-center gap-x-4'}>
                        <div
                            className={
                                'flex size-10 shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-500'
                            }
                        >
                            <FontAwesomeIcon icon={faSend} />
                        </div>
                        <p className={'flex-wrap'}>
                            <CreatedByLabel createdBy={item.created_by} /> sent{' '}
                            <span className="font-medium">{name_display}</span> a letter
                        </p>
                        <p className="flex shrink-0 items-center gap-x-3 font-medium">
                            <span className="[&>*]:inline">
                                <FontAwesomeIcon icon={faEnvelope} />
                            </span>
                            <span>Sent with Engage</span>
                        </p>
                    </div>
                    <div className="flex items-center gap-5">{getBadge(resource)}</div>
                </div>
            </div>
        </Box>
    );
};

export { EngageLetter };
